import React from 'react';
import PropTypes from 'prop-types';

import ExpirationField from './components/ExpirationField';
import LicenseNumberField from './components/LicenseNumberField';

const applicatorLicenseDefaultPropLicense = {};
const ApplicatorLicense = ({
  license = applicatorLicenseDefaultPropLicense,
  onChange
}) => {
  const updateLicense = event => {
    const updatedLicense = event.target.value;
    onChange(prevData => ({
      ...prevData,
      value: updatedLicense,
      licenseType: 'Applicator'
    }));
  };

  const updateExpiry = expiry => {
    onChange(prevData => ({
      ...prevData,
      expiry,
      licenseType: 'Applicator'
    }));
  };

  return (
    <div className="my-4 w-full">
      <div>
        <div className="text-2xl font-bold mt-10">License Info</div>
        <div className="flex" data-testid="applicatorLicenseUI">
          <div className="flex w-full">
            <LicenseNumberField
              title="Applicator License"
              onChange={updateLicense}
              licenseNumber={license.value}
            />
          </div>
          <div className="flex w-full">
            <ExpirationField
              onChange={updateExpiry}
              expiration={license.expiry}
              title="Valid Through"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ApplicatorLicense.propTypes = {
  license: PropTypes.shape({
    value: PropTypes.string,
    expiry: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    licenseType: PropTypes.string
  }),
  onChange: PropTypes.func.isRequired
};

export default ApplicatorLicense;
